import React from "react";
import { Link } from "react-router-dom";
import Icon from "../../Icon";

const ServiceHome = () => {

    return (
        <div className="services reveal" id="services">
            <div className="services-head">
                <h2 className="service-title reveal_1   ">Redéfinissons notre stratégie marketing</h2>
                <p className="reveal_2">
                Nous sommes une entreprise numérique créative axée sur la qualité des solutions innovantes à un coût abordable. Nos créations digitales full-service : la production vidéo, le web design, le branding, le branding...
                </p>
            </div>
            <div className="service-body grid3 reveal_3">
                <div className="service-item ">
                    <div className="service-item-back">
                        <div className="service-item-head">
                            <h2 className="service-title2">Marque</h2>
                        </div>
                        <div className="service-item-body">
                            <ul>
                                <li><Link to="" className="service-link">Identité de marque</Link></li>
                                <li><Link to="" className="service-link">Conception artistique</Link></li>
                                <li><Link to="" className="service-link">Conception visuelle</Link></li>
                                <li><Link to="" className="service-link">Illusctration & infographie</Link></li>
                                <li><Link to="" className="service-link">Contenu/Vidéo</Link></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="service-item ">
                    <div className="service-item-back">
                        <div className="service-item-head">
                            <h2 className="service-title2">Conception graphique</h2>
                        </div>
                        <div className="service-item-body">
                            <ul>
                                <li><Link to="" className="service-link">Conception créative</Link></li>
                                <li><Link to="" className="service-link">Applications & Mobile</Link></li>
                                <li><Link to="" className="service-link">Expérience utilisateur</Link></li>
                                <li><Link to="" className="service-link">Conception de mouvement</Link></li>
                                <li><Link to="" className="service-link">Conception de l'interface</Link></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="service-item">
                    <div className="service-item-back">
                        <div className="service-item-head">
                            <h2 className="service-title2">Développement</h2>
                        </div>
                        <div className="service-item-body">
                            <ul>
                                <li><Link to="" className="service-link">Développement back-end</Link></li>
                                <li><Link to="" className="service-link">Développement frontal</Link></li>
                                <li><Link to="" className="service-link">Développement Web</Link></li>
                                <li><Link to="" className="service-link">Applications & Jeux</Link></li>
                                <li><Link to="" className="service-link">E-services</Link></li>
                            </ul>
                        </div>
                    </div>
                    
                </div>
            </div>
            <div className="service-foot reveal_4">
                <Link to="" className="service-foot-link">Voir nos services <span className="service-icon"><Icon name="moins"/></span> </Link>
            </div>
            
        </div>
    )
}

export default ServiceHome;